import { Data } from './types';
import {
  FETCH_DATA,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_ERROR,
} from './actions';
import {
  UPDATE_ROUTES_NAVIGATE,
  RESET_ROUTES_NAVIGATE,
  type TNewRoureStack,
} from './routeStack/types';
import { mappingRouteStack } from './routeStack/helper';
import {categories} from "../utils/category";

export interface DataState {
  data: Data[];
  uploading: number;
  upgradeRequired: string|boolean;
  nativeReady: number;
  loading: boolean;
  error: Error | null;
  deviceData: any;
  debugMode: number;
  debugLog: any;
  categories: any;
  routes: TNewRoureStack[];
}

const initialState: DataState = {
  data: [],
  uploading: 0,
  upgradeRequired: false,
  nativeReady: 0,
  deviceData: {},
  loading: false,
  error: null,
  debugMode: 0,
  debugLog: "",
  categories: categories,
  routes: [] as TNewRoureStack[],
};

const CommonReducer = (
  state: DataState = initialState,
  action: any,
): DataState => {
  //console.log(22, action.type)
  switch (action.type) {
    case FETCH_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_DATA_SUCCESS:
      return { ...state, data: action.payload, loading: false, error: null };
    case FETCH_DATA_ERROR:
      return { ...state, loading: false, error: action.payload };
    case "SET_DEBUG_MODE":
      return { ...state, debugMode: state.debugMode+1, loading: false, error: null };
    case "SET_DEBUG_LOG":
      return { ...state, debugLog: JSON.stringify(action.payload), loading: false, error: null };
    case "UPLOADING":
      return { ...state, uploading: state.uploading+1, loading: false, error: null };
    case "UPLOAD_SUCCESS":
      return { ...state, uploading: state.uploading-1, loading: false, error: null };
    case "UPGRADE_REQUIRED":
      console.log(52,"UPGRADE_REQUIRED", action )
      return { ...state, upgradeRequired: action.payload, loading: false, error: null };
    case "NATIVE_READY":
      return { ...state, nativeReady: state.nativeReady+1, deviceData: action.payload, loading: false, error: null };

    // route stack
    case UPDATE_ROUTES_NAVIGATE:
      return {
        ...state,
        routes: mappingRouteStack(state.routes, action.payload),
      };
    case RESET_ROUTES_NAVIGATE:
      return {
        ...state,
        routes: [],
      };
    default:
      return state;
  }
};

export default CommonReducer
